import camera from './camera.png'
import github_white from './github_white.png'
import linkedin_cyan from './linkedin_cyan.png'
import Star from './Star.png'
import amandalorian from './amandalorian.png'
import rock from './rock.png'
import tictaccatjam from './tictaccatjam.png'
import rockcollector from './rockcollector.png'
import python from './python.png'
import lamdb from './lamdb.png'
import Self8 from './Self8.jpg'
import adobefonts from './adobefonts.svg'
import adobeillustrator from './adobeillustrator.svg'
import adobelightroom from './adobelightroom.svg'
import adobephotoshop from './adobephotoshop.svg'
import bootstrap2 from './bootstrap2.svg'
import css3 from './css3.svg'
import django from './django.svg'
import docker from './docker.svg'
import dotenv from './dotenv.svg'
import express from './express.svg'
import heroku from './heroku.svg'
import html5 from './html5.svg'
import javascript from './javascript.svg'
import jsonwebtokens from './jsonwebtokens.svg'
import microsoftazure from './microsoftazure.svg'
import mongodb from './mongodb.svg'
import mui from './mui.svg'
import nephria from './Nephria.jpg'
import netlify from './netlify.svg'
import nodedotjs from './nodedotjs.svg'
import nodemon from './nodemon.svg'
import npm from './npm.svg'
import postgresql from './postgresql.svg'
import postman from './postman.svg'
import python2 from './python2.svg'
import react from './react.svg'
import visualstudiocode from './visualstudiocode.svg'
import ga from './ga.png'
import AT from './AT.png'
import DOI from './DOI.png'
import OSU from './OSU.png'
import CSN from './CSN.png'
import OB from './OB.png'
import NOLS from './NOLS.png'
import AF from './AF.png'
import Cornell from './Cornell.png'
import calculator from './calculator.png'
import YelpCamp from './YelpCamp.png'
import cabem from './cabem_logo.jpg'
import php from './php.svg'
import mysql from './mysql.svg'
import gitlab from './gitlab.svg'
import WCLCC from './WCLLC.png'
import pmpBadge from './pmpBadge.svg'

const pmp_badge = {
  src: pmpBadge,
  altText: 'Official PMP Badge'
}

const WCLLC_icon = {
  src: WCLCC,
  altText: 'WCLCC Logo'
}

const github_icon = {
  src: github_white,
  altText: 'white icon for github'
}

const linkedin_icon = {
  src: linkedin_cyan,
  altText: 'cyan icon for linkedin'
}

const camera_icon = {
  src: camera,
  altText: 'red camera icon for photography website'
}

const star_icon = {
  src: Star,
  altText: 'White star icon links to landing page'
}

const yelpcamp_screenshot = {
  src: YelpCamp,
  altText: 'Screen shot of honme page sunset view for YelpCamp application'
}

const amandalorian_screenshot = {
  src: amandalorian,
  altText: 'Screen shot of Amandalorian game, Mando from Disney with Baby Yoda'
}

const rock_screenshot = {
  src: rock,
  altText: 'Screen shot of Rock and Ice, featuring climbing partners on a user profile'
}

const tictaccatjam_screenshot = {
  src: tictaccatjam,
  altText: 'Screen shot of Tic Tac Cat Jam, featuring confetti and colorful board'
}

const rockcollector_screenshot = {
  src: rockcollector,
  altText: 'Screen shot of Rock Collector, featuring a pile of rocks and a frog in the dark woods'
}

const python_icon = {
  src: python,
  altText: 'Logo for Python'
}

const lamdb_screenshot = {
  src: lamdb,
  altText: 'Screen shot of LAMdb, featuring a cute fluffy lamb.'
}

const Self8_image = {
  src: Self8,
  altText: 'Amanda in red sweater and glasses smiling'
}

const adobefonts_svg = {
  src: adobefonts,
  altText: 'Adobe Fonts logo'
}

const adobeillustrator_svg = {
  src: adobeillustrator,
  altText: 'Adobe Illustrator logo'
}

const adobelightroom_svg = {
  src: adobelightroom,
  altText: 'Adobe Lightroom logo'
}

const adobephotoshop_svg = {
  src: adobephotoshop,
  altText: 'Adobe Photoshop logo'
}

const bootstrap2_svg = {
  src: bootstrap2,
  altText: 'Bootstrap logo'
}

const css3_svg = {
  src: css3,
  altText: 'CSS3 logo'
}

const django_svg = {
  src: django,
  altText: 'Django logo'
}

const docker_svg = {
  src: docker,
  altText: 'Docker logo'
}

const dotenv_svg = {
  src: dotenv,
  altText: 'Dotenv logo'
}

const express_svg = {
  src: express,
  altText: 'Express logo'
}

const heroku_svg = {
  src: heroku,
  altText: 'Heroku logo'
}

const html5_svg = {
  src: html5,
  altText: 'HTML5 logo'
}

const javascript_svg = {
  src: javascript,
  altText: 'Javascript logo'
}

const jsonwebtokens_svg = {
  src: jsonwebtokens,
  altText: 'JSON Web Token logo'
}

const microsoftazure_svg = {
  src: microsoftazure,
  altText: 'Microsoft Azure logo'
}

const mongodb_svg = {
  src: mongodb,
  altText: 'MongoDB logo'
}

const mui_svg = {
  src: mui,
  altText: 'MUI Logo'
}

const netlify_svg = {
  src: netlify,
  altText: 'Netlify logo'
}

const nodedotjs_svg = {
  src: nodedotjs,
  altText: 'Node.js logo'
}

const nodemon_svg = {
  src: nodemon,
  altText: 'Nodemon logo'
}

const npm_svg = {
  src: npm,
  altText: 'NPM logo'
}

const postgresql_svg = {
  src: postgresql,
  altText: 'PostgresSQL logo'
}

const postman_svg = {
  src: postman,
  altText: 'Postman logo'
}

const python2_svg = {
  src: python2,
  altText: 'Python logo'
}

const react_svg = {
  src: react,
  altText: 'React logo'
}

const visualstudiocode_svg = {
  src: visualstudiocode,
  altText: 'VSCode logo'
}

const ga_logo = {
  src: ga,
  altText: 'General Assembly logo'
}

const AT_logo = {
  src: AT,
  altText: 'Appalachian Trail logo'
}

const DOI_logo = {
  src: DOI,
  altText: 'Department of the Interior logo'
}

const OSU_logo = {
  src: OSU,
  altText: 'Oregon State University logo'
}

const CSN_logo = {
  src: CSN,
  altText: 'College of Southern Nevada logo'
}

const OB_logo = {
  src: OB,
  altText: 'Outward Bound logo'
}

const NOLS_logo = {
  src: NOLS,
  altText: 'NOLS logo'
}

const AF_logo = {
  src: AF,
  altText: 'US Air Force emblem'
}

const Cornell_logo = {
  src: Cornell,
  altText: 'Cornell University logo'
}

const calculator_screenshot = {
  src: calculator, 
  altText: 'Screenshot of calculator application'
}

const Cabem = {
  src: cabem,
  altText: 'Cabem Technologies logo'
}

const Nephria = {
  src: nephria,
  altText: 'Nephria Bio logo'
}

const php_svg = {
  src: php,
  altText: 'PHP logo'
}

const mysql_svg = {
  src: mysql,
  altText: 'mysql svg'
}

const gitlab_svg = {
  src: gitlab,
  altText: 'gitlab svg'
}

export {
  camera_icon,
  github_icon,
  linkedin_icon,
  star_icon,
  amandalorian_screenshot,
  rock_screenshot,
  tictaccatjam_screenshot,
  rockcollector_screenshot,
  python_icon,
  lamdb_screenshot,
  Self8_image,
  adobefonts_svg,
  adobeillustrator_svg,
  adobelightroom_svg,
  adobephotoshop_svg,
  bootstrap2_svg,
  css3_svg,
  django_svg,
  docker_svg,
  dotenv_svg,
  express_svg,
  heroku_svg,
  html5_svg,
  javascript_svg,
  jsonwebtokens_svg,
  microsoftazure_svg,
  mongodb_svg,
  mui_svg,
  netlify_svg,
  nodedotjs_svg,
  nodemon_svg,
  npm_svg,
  postgresql_svg,
  postman_svg,
  python2_svg,
  react_svg,
  visualstudiocode_svg,
  ga_logo,
  AT_logo,
  DOI_logo,
  OSU_logo,
  CSN_logo,
  OB_logo,
  NOLS_logo,
  AF_logo,
  Cornell_logo,
  calculator_screenshot,
  yelpcamp_screenshot,
  Cabem,
  php_svg,
  mysql_svg,
  gitlab_svg,
  Nephria,
  WCLLC_icon,
  pmp_badge,
}